import { app } from '../../app';
import { Controller } from './sp-global-search.controller';

app.component('spGlobalSearch', {
    controller: Controller,
    templateUrl: require('./sp-global-search.html'),
});



// WEBPACK FOOTER //
// ./src/portal/components/sp-global-search/sp-global-search.component.js